export default {
  "h1-title": "Trading Tools",
  imgUrlLang: "-en",
  "public-btn-text": "Instant experience",
  screen0: {
    title: "Create a library of tools to meet your trading needs",
  },
  screen1: {
    title: "Overlay Chart Indicator",
    desc: "This tool enables investors to gain a clear understanding of the relative strength of candlesticks within any given period for two commodities. Additionally, it can identify the effectiveness of breakthroughs.",
  },
  screen2: {
    title: "MACD professional indicator (double line)",
    desc: "This MACD indicator tool is widely used for stocks and futures. It offers several advantages over the MACD included with MT4, making it better suited to traders' preferences and habits.",
  },
  screen3: {
    title: "MTDriver profit and loss statistical indicators",
    desc: "This tool can help investors pinpoint profit and loss for different periods",
  },
  screen4: {
    title: "Price Change Mobile Push Notification",
    desc: "Most investors have limited time to watch the market, and mobile phone notification of price changes can help them grasp market trends while avoiding some market noises",
  },
  screen5: {
    title: "One-click closing EA",
    desc: "The operation interface is located in the chart interface, which is convenient for investors to stop losses more quickly and conveniently when extreme market conditions occur",
  },
  screen6: {
    title: "Timing order EA",
    desc: "Put it in the MQL4Experts folder, an EA that places orders at a specified time, the usage is very simple, users please explore by themselves",
  },
  screen7: {
    title: "Equity Monitor EA",
    desc: "Put it in the MQL4Experts folder, monitor the EA of the net value change, put the sound file you want to prompt under Sounds, and then fill in the name of the corresponding music file in the music name of the EA",
  },
  EA交易与指标: "EA Trading and MetaTrader Indicators",
  EBC独家精选的MT4:
    "EBC's exclusive selection of MT4 and MT5 indicators and EA trading tools enhances your decision-making accuracy and operational efficiency, enabling you to optimise strategies, seize market opportunities, and gain a competitive edge.",
  EBCTurbo账户分析系统:
    "EBC Turbo: Analyse trades with MetaTrader indicators to optimise strategies.",
  实用型技术指标集:
    "Practical Indicators: Master market trends and seize trading opportunities.",
  外汇EA策略执行器:
    "Forex EA strategy executor that efficiently responds to market changes and keeps your decisions ahead of the curve.",
  EBCTurbo账户分析系统2: "EBC Turbo Account Analysis System",
  EBC独家盈亏统计和历史回溯工具:
    "EBC’s Exclusive P&L and History Tool provide multi-dimensional analysis and deep integration to optimise your trading strategies.",
  净值收益曲线: "Equity Return Curve",
  收益率: "Profit Rate",
  最大回撤: "Maximum Drawdown",
  标准差: "Standard Deviation",
  获利系数: "Profit Factor",
  夏普比率: "Sharpe Ratio",
  盈利交易: "Profitable Trades (Winning Percentage)",
  六维评级图: "Six-Dimensional Rating Chart",
  每日: "Daily/Monthly Statistics",
  获取EBCTurbo: "Unlock EBC Turbo",
  实用型技术指标集2: "Practical Technical Indicator Set",
  经过优化的常用技术指标:
    "Optimised technical indicators for multi-angle market analysis and custom configurations to precisely gauge trends.",
  同图商品叠加工具: "Overlay Chart Indicator",
  帮助投资者通过叠加两个商品的走势:
    "Helps traders analyse the strength of low resistance lines between two products, identify key breakout points, and enhance decision accuracy.",
  MACD专业指标: "MACD Pro Indicator (Dual Line)",
  提供比普通MACD更为精准的双线指标:
    "Offers a more precise dual-line MACD indicator than standard versions, helping investors better identify market buy and sell signals to capture superior profit opportunities.",
  MTDriver盈亏统计指标: "MTDriver P&L Statistics",
  该指标可协助投资者实时统计不同周期内的盈亏情况:
    "Helps investors track profit and loss across timeframes in real time, offering data-driven support for more accurate trading strategies.",
  价格变动手机推送通知: "Price Change Mobile Notifications",
  实时监控市场价格波动:
    "Real-time monitoring of market price fluctuations, with push notifications sent immediately to investors' phones when significant changes occur, ensuring they can respond swiftly at crucial moments.",
  获取指标: "Get Indicator",
  外汇EA策略执行器2: "Forex EA Strategy Executor",
  基于高级算法自动执行EA交易策略:
    "Executes EA trading strategies with advanced algorithms, adapting in real time to market changes for fast, secure, and efficient performance.",
  定时下单EA软件: "Timed Order EA Software",
  通过MT4EA:
    "Places orders automatically at preset times via MT4 or MT5, with no manual input required. Perfect for time-based strategies that demand precision and reliability.",
  EA交易常见问题: "EA Trading-related Questions",
  qaList: [
    {
      q: "1. What is EA trading and how does it work?",
      a: [
        "EA (Expert Advisor) trading refers to using automated systems on MT4 or MT5 platforms to carry out trades. These systems follow preset strategies to buy, sell, and set stop-loss and take-profit levels automatically. They allow traders to improve execution efficiency, save screen time, and reduce emotional influence in trading decisions.",
      ],
    },
    {
      q: "2. What are the differences between EA software on different trading platforms?",
      a: [
        "MT4 EAs are written in MQL4 and run only on MetaTrader 4, while MT5 EAs use MQL5 on the MetaTrader 5 platform. MT5 supports more features and allows multi-threaded backtesting. Your choice depends on trading requirements and EA compatibility, as the two platforms are not compatible with each other.",
      ],
    },
    {
      q: "3. Can I run multiple EA programmes on the same platform?",
      a: [
        "Yes, but each EA must be loaded onto a separate chart. You can run several EAs on the same MetaTrader platform as long as they are on different charts. Only one EA can operate per chart, so take care to avoid conflicts or resource overload.",
      ],
    },
    {
      q: "4. Can a forex EA trade multiple currency pairs at once?",
      a: [
        "Yes, although this depends on how the EA is designed. Some EAs focus on a single currency pair, while others, especially those built for MT5, can trade across multiple instruments more effectively thanks to the platform’s multi-threading capabilities.",
      ],
    },
    {
      q: "5. How do I choose the right forex EA for me?",
      a: [
        "Consider your trading style, whether trend-following or scalping, your capital tolerance, and your risk preferences. Check the EA’s backtesting data, live trading performance, and whether it is suited for MT4 or MT5. Always test it on a demo account before using it in live trading.",
      ],
    },
    {
      q: "6. Can EA trading guarantee profits?",
      a: [
        "No trading tool can guarantee profits. EA performance depends on the logic behind the strategy, market conditions, and risk management. Both MT4 and MT5 EAs are tools to support trading, but traders still need to monitor performance and make adjustments where necessary.",
      ],
    },
  ],
  url: "https://ebcturbo.com/tools?language=en",
};
